function _track(properties) {
  if (typeof window !== 'object' || !window._paq) {
    console.warn('Trying to track while tracking is not available');
    return;
  }
  window._paq.push(properties);
}

function trackEvent(category, action, name, value) {
  _track(['trackEvent', category, action, name, value]);
}

function trackContentInteractionNode(domNode, contentInteraction) {
  _track(['trackContentInteractionNode', domNode, contentInteraction]);
}

function setCustomUrl(url) {
  _track(['setCustomUrl', url]);
}

function trackPageView() {
  _track(['trackPageView']);
}

function trackContentImpressions() {
  _track(['trackVisibleContentImpressions', false, 600]);
}

export {
  trackEvent,
  trackContentInteractionNode,
  setCustomUrl,
  trackPageView,
  trackContentImpressions,
};
